export default "__VITE_ASSET__BEXZ8s1P__"